import { useState } from 'react';
import { Marker, Popup } from 'react-map-gl/mapbox';
import { getDynamicMapElementZIndex, MapElement } from '../../../../types/ui/mapElement';
import { RiskVolume, type AircraftId } from '../../../../types/gcs/foreignAircraft';
import { Text } from '../../../../components/general/Text';

interface ForeignAircraftMarkerProps {
  aircraftId: AircraftId;
  longitude: number;
  latitude: number;
  altitude: number;
  heading?: number | null;
  riskVolume?: RiskVolume;
}

export const ForeignAircraftMarker = ({
  aircraftId,
  longitude,
  latitude,
  altitude,
  heading,
  riskVolume
}: ForeignAircraftMarkerProps) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const fillColor =
    riskVolume === RiskVolume.NOMINAL
      ? 'var(--map-element-inflight-nominal)'
      : 'var(--map-element-inflight-failure-mode)';

  return (
    <>
      <Marker
        longitude={longitude}
        latitude={latitude}
        anchor='center'
        rotation={heading ?? 0}
        style={{
          zIndex: getDynamicMapElementZIndex(MapElement.FOREIGN_AIRCRAFT, altitude)
        }}
      >
        <svg
          version='1.1'
          id='Icons'
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 40 40'
          width='32'
          height='32'
          style={{ cursor: 'pointer' }}
          onClick={(event) => {
            event.stopPropagation();
            setIsPopupOpen((prev) => !prev);
          }}
        >
          <path
            d='M37.5,26.25v-5l-13.75,-7.625V5c0,-2.125,-1.625,-3.75,-3.75,-3.75h0c-2.125,0,-3.75,1.625,-3.75,3.75v8.625L2.5,21.25v5l13.75,-3.875V31.25l-3.75,2.5v5l7.5,-2.5l7.5,2.5v-5l-3.75,-2.5v-8.875
	L37.5,26.25z'
            fill={fillColor}
            stroke='#ffffff'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeMiterlimit='10'
          />
        </svg>
      </Marker>
      {isPopupOpen && (
        <Popup
          longitude={longitude}
          latitude={latitude}
          anchor='bottom'
          offset={32}
          className='marker-popup'
          closeButton={true}
          closeOnClick={true}
          onClose={() => setIsPopupOpen(false)}
        >
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
            <Text variant='body2'>{aircraftId}</Text>
          </div>
        </Popup>
      )}
    </>
  );
};
